import FormattedMessage from 'I18n/components/FormattedMessage';
import { BreezeSingleStarIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Image } from 'foundations-components/transitional/components/Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function IconPill({
  title,
  customImage
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    borderStyle: "groove",
    borderRadius: "full",
    borderWidth: "100",
    marginBlock: "100",
    flexDirection: "row",
    paddingBlock: "50",
    children: [customImage ? /*#__PURE__*/_jsx(Image, {
      blockSize: "12px",
      inlineSize: "12px",
      marginInlineStart: "200",
      marginInlineEnd: "100",
      alignSelf: "center",
      padding: "25",
      src: customImage.imageSrc,
      alt: customImage.imageAlt
    }) : /*#__PURE__*/_jsx(IconHolder, {
      icon: BreezeSingleStarIcon,
      color: "fill-accent-magenta-default",
      size: "100"
    }), /*#__PURE__*/_jsx(Text, {
      children: title
    })]
  });
}
export function SkillsList({
  skills
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "100",
    children: [/*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "detailsPage.functionalityCard.tabs.skills.description"
      })
    }), /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "100",
      children: skills.map(skill => /*#__PURE__*/_jsx(IconPill, {
        title: skill.title,
        customImage: skill.customImage
      }, skill.title))
    })]
  });
}